import { GAME_ID, REDUX_ACTIONS, FLUENCY_VISITED_SESSION_KEY } from '../../data/constants';

const createActionObj = (type, payload) => ({
  type,
  payload,
  gameId: GAME_ID,
});

export const setPassageContent = (content) =>
  createActionObj(REDUX_ACTIONS.SET_PASSAGE_CONTENT, content);

export const setFluencyAssignment = (assignment) =>
  createActionObj(REDUX_ACTIONS.SET_FLUENCY_ASSIGNMENT, assignment);

export const clearFluencyAssignment = () =>
  createActionObj(REDUX_ACTIONS.CLEAR_FLUENCY_ASSIGNMENT);

export const setFluencyVisited = (persist = false) => (dispatch) => {
  if (persist) {
    sessionStorage.setItem(FLUENCY_VISITED_SESSION_KEY, 'true');
  }
  dispatch(createActionObj(REDUX_ACTIONS.SET_FLUENCY_VISITED));
};

export const setFluencySuppressionArmed = (armed) =>
  createActionObj(REDUX_ACTIONS.SET_FLUENCY_SUPPRESSION_ARMED, armed);
